export default __webpack_public_path__ + "static/curve-a3a6bc151b37b3d7cf528112c4d0afb4.png";